import {
  type MutationHookOptions,
  type MutationTuple,
} from '@apollo/client/react/types/types'
import { useMutation } from '@apollo/client'

import { useOnErrorAuto } from '@/utils'
import {
  type CreateFileArchiveMutation,
  type CreateFileArchiveMutationVariables,
} from './types.graphql'
import { UPLOAD_FILE_TO_ARCHIVE_MUTATION } from './queries'

type TData = CreateFileArchiveMutation
type TVariables = CreateFileArchiveMutationVariables

type Props = MutationHookOptions<TData, TVariables>

type Return = MutationTuple<TData, TVariables>

const useFileArchive = (props: Props): Return => {
  const onErrorAuto = useOnErrorAuto()

  const uploadMutation = useMutation<TData, TVariables>(
    UPLOAD_FILE_TO_ARCHIVE_MUTATION,
    {
      onError: onErrorAuto(),
      ...props,
    }
  )

  return uploadMutation
}

export default useFileArchive
